module.exports = __webpack_public_path__ + "static/Group_6104_2x-bfb2b2b4caecba20c11fe6521fac384c.png";